import PropTypes from 'prop-types';
import { useUserContext } from '../../contexts/user-context';
import { userHasAccess } from '../../utils/profile';

const propTypes = {
  userSpecificPromo: PropTypes.shape({
    userContent: PropTypes.shape({}),
    fallbackContent: PropTypes.shape({}),
  }).isRequired,
  children: PropTypes.func.isRequired,
};

const UserSpecificPromo = ({ userSpecificPromo, children }) => {
  const userContext = useUserContext();
  const resultPromo = userHasAccess(userSpecificPromo, userContext)
    ? userSpecificPromo.userContent
    : userSpecificPromo.fallbackContent;

  return children({ resultPromo });
};

UserSpecificPromo.propTypes = propTypes;
export default UserSpecificPromo;
